module.exports = __webpack_public_path__ + "img/product_banner.8ec8b663.jpg";